export default __webpack_public_path__ + "static/media/dignity-memorial-logo.69424dde.svg";